import loadable from '@loadable/component';

export const CmsLogosBlockLoadable = loadable(() => import('./CmsLogosBlock'), {
  resolveComponent: (module) => module.CmsLogosBlock,
});
